// function to format time in -> 12 min 1 hr 1 day etc..
export const formatTime = (dateTimeString) => {
  if (!dateTimeString) return ""; // If dateTimeString is empty, return empty string
  try {
    const currentTime = new Date();
    const dateTime = new Date(dateTimeString);
    const elapsedTime = currentTime - dateTime;

    // Convert elapsed time to seconds
    const seconds = Math.floor(elapsedTime / 1000);

    if (seconds < 60) {
      return `${seconds} sec ago`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes} min ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      return `${hours} hour ago`;
    } else {
      const days = Math.floor(seconds / 86400);
      return `${days} day ago`;
    }
  } catch (error) {
    console.error("Error calculating time ago:", error);
    return ""; // Return empty string if an error occurs
  }
};
